
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/subscription-preferences",
      function () {
        return require("private-next-pages/account/subscription-preferences/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/subscription-preferences"])
      });
    }
  